import React from 'react';
import {Row, Col, MenuItem, DropdownButton} from 'react-bootstrap';
import {setNoItemImage} from '../../common/utils';

class RecurringItem extends React.Component {
    onSelectionSchedule = (scheduleKey) => {
        const schedule = scheduleKey!=="Once"?this.props.farmSchedules[scheduleKey]:undefined;
        const item = this.props.item;
        if(schedule !== undefined) {
            item.isRecurring = true;
            if(schedule.dates.includes(this.props.nextDeliveryDate)) {
                item.isItemNotPartOfOrder = false;
                if(!item.schedule) {
                    item.schedule = schedule;
                    this.props.setRecurringItem(item, true);
                } else {
                    item.schedule = schedule;
                    this.props.updateWebOrder(item);
                }
            } else {
                item.schedule = schedule;
                item.isItemNotPartOfOrder = true;
                this.props.updateWebOrder(item, true);
            }
        } else if(item.schedule !== undefined) {
            item.schedule = undefined;
            item.isItemNotPartOfOrder = false;
            this.props.updateWebOrder(item);
        }
    };

    getSchedules = (item) => {
        let schedules = [];
        let index = 0;
        for (let schedulesKey in this.props.farmSchedules) {
            if (this.props.farmSchedules.hasOwnProperty(schedulesKey)) {
                schedules.push(<MenuItem key={schedulesKey} eventKey={schedulesKey} id={index++}>{this.props.farmSchedules[schedulesKey].title}</MenuItem>);
            }
        }
        schedules.unshift(<MenuItem key="Once" eventKey="Once" id={-1}>Once</MenuItem>);
        return (<DropdownButton className="recurring-schedules-selection" noCaret
                                disabled={this.props.disabled || item.available <= 0}
                                id="state-selection" onSelect={this.onSelectionSchedule}
                                title={item.schedule?this.props.farmSchedules[item.schedule.key].title:"Once"}>
            {schedules}
        </DropdownButton>);
    };

    render() {
        const item = this.props.item;
        return (<div className="order-summary-item-wrapper">
            <Row className="order-summary-item">
                <Col xs={2} md={2} className="order-summary-item-img"><img src={item.imageUrl} onError={setNoItemImage}/></Col>
                <Col xs={5} md={3} className="recurring-item-details">
                    <div className="recurring-item-name">{item.title}</div>
                    <div className="price" name="recurringItemPrice">{(item.isCredit?"":"$") + item.price}{item.isCredit && !this.props.staticData.isCreditItemAsRegularItem?' ' + this.props.staticData.creditItemLabel.toLocaleLowerCase():""}
                        <span
                            className="unit">{item.unit ? " / " + item.unitQuantity + " " + item.unit.replace("credits", this.props.staticData.creditItemLabel) : undefined} </span>
                    </div>
                </Col>
                <Col xs={4} md={5} className="schedules-and-quantity-wrapper">
                    {this.getSchedules(item)}
                </Col>
                <Col xs={1} md={2} className="order-summary-item-qty">{item.quantity}</Col>
            </Row>
            <hr className="recurring-item-divider"/>
        </div>);
    }
}

export default RecurringItem;


// WEBPACK FOOTER //
// ./src/components/store/RecurringItem.js